import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import DatePicker from '../../date-picker/DatePicker.jsx';
import moment from 'moment';
import modules from '../../../assets/modules-map.json';
import BAASummaryTable from '../../../components/ap-generics/components/BAASummaryTable/BAASummaryTable';
import syncRowHeights from '../../../helpers/syncRowHeights';
import request from '../../../helpers/request.js';
import endpoints from '../../../helpers/endpoints.js';
import session from '../../../stores/session.js';
import getWorkflowStatuses from '../../../helpers/getWorkflowStatuses.js';
import ReactModal from 'react-modal';
import { SummaryTable as MCVSummaryTable } from '../../../pages/modules/MeterCoordinatesValidation/shared.jsx';

export const getRejectIsDisabled = ({ customer = {}, qualityAssurance = false } = {}) => {
  let isDisabled = true;

  if (!qualityAssurance) return isDisabled;

  const completeStatus = customer?.Complete_Status;
  const assuredStatus = customer?.Assured_Status;
  const isCompleted = ["Complete", "Complete & Assured"].includes(customer?.WS_Outcome);
  const isAssured = ["Assured", "Complete & Assured"].includes(customer?.WS_Outcome);
  const isQualityCheckPassed = customer?.WS_Outcome === 'Quality Check Passed';
  const isCompleteDownloaded = completeStatus !== "Data Cleanse Export Pending";
  const isAssuredDownloaded = assuredStatus !== "Assured Export Pending";
  const isCompleteStatusCompatibleWithReject = !isCompleteDownloaded || !completeStatus;
  const isAssuredStatusCompatibleWithReject = !isAssuredDownloaded || !assuredStatus;

  if (isQualityCheckPassed) {
    if (isCompleteStatusCompatibleWithReject) {
      isDisabled = false;
    } else {
      return true;
    }

    if (isAssuredStatusCompatibleWithReject) {
      isDisabled = false;
    } else {
      return true;
    }
  }

  if (isCompleted && !isCompleteDownloaded) {
    isDisabled = false;
  } else if (isCompleted) {
    return true;
  }

  if (isAssured && !isAssuredDownloaded) {
    isDisabled = false;
  } else if (isAssured) {
    return true;
  }

  return isDisabled;
};

export default function Summary ({summaryData, setSummaryData, workflow = false, setMdsData, setMdsDataReady, translations = {}, getMDSData, setConfirmModal, prefix, disabledByUserType, setDisabledByUserType, qualityAssurance, selectedModule, setSelectedModule, customMDSPostcode, setMdsMeterData, displayModuleIssues}) {
  const history = useHistory();
  const { state } = history.location;
  const [spid, setSpid] = useState(state?.spid)
  const [loadingSpid, setLoadingSpid] = useState(false)
  const [loadingWorkflow, setLoadingWorkflow] = useState(false)
  const [search, setSearch] = useState()
  const [spidSearch, setSpidSearch] = useState(null)
  const [wSpid, setWSpid] = useState()
  const [sSpid, setSSpid] = useState()
  const [wsOutcome, setWsOutcome] = useState('')
  const [wholesalerNotes, setWholesalerNotes] = useState('')
  const [wsNoteIndex, setWsNoteIndex] =  useState()
  const [prevWsNotes, setPrevWsNotes] =  useState([])
  const [workflowItems, setWorkflowItems] = useState([])
  const [workflowCounts, setWorkflowCounts] = useState([])
  const [workflowOutcomeSetting, setWorkflowOutcomeSetting] = useState('New')
  const [bulkRejectModelOpen, setBulkRejectModelOpen] = useState(false)
  const [loadingReject, setLoadingReject] = useState(false)
  const [searchResults, setSearchResults] = useState()
  const [searchIsLoading, setSearchIsLoading] = useState(false)
  const [rejectIsDisabled, setRejectIsDisabled] = useState(true)
  const links = {
    'Automated Address Cleanse': '/portal/automated-address-cleanse/search',
    'Invalid Postcode Street': '/portal/invalid-postcode-street/search',
    'UPRN/VOA Address Conflicts': '/portal/invalid-uprn-voa/search',
    'Invalid UPRN/VOA CMOS Reference': '/portal/invalid-uprn-voa-cmos/search',
    'Non-Addressable': '/portal/undeliverable/search'
  }

  const [fromTime, setFromTime] = useState(moment().utc().locale('en-gb').subtract(7, 'days').startOf('day'));
  const [toTime, setToTime] = useState(moment().utc().locale('en-gb').startOf('day'));
  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState()
  const [selectedStatus, setSelectedStatus] = useState()

  useEffect(() => {
    syncRowHeights()
  }, [translations])

  const reset = () => {
    setSummaryData({})
    setWholesalerNotes('')
    setWsOutcome('')
    setMdsData(false)
    setMdsDataReady(true)
    setPrevWsNotes([])
    setWsNoteIndex(0)
    setLoadingSpid(false)
    setRejectIsDisabled(true)
  }

  const getSummaryData = useCallback((spidSearch, spidType) => {
    setSearch()
    setSummaryData({})
    setWsOutcome('')
    setLoadingSpid(true)
    request(true).get(endpoints[`${prefix}_SEARCH_BY_SPID`], {
      doesCancel: true,
      params: {
        spid: spidSearch || spid,
        spidType: spidType
      }
    }).then(e => {
      setSummaryData(e.data.customer ?? {})
      if (e.data.meterSearch) {
        setSpid(e.data.customer.Meter_ID)
      } else {
        setSpid(e.data.customer.Core_SPID)
      }
      if (spidType === "wSpid") {
        setSearch('')
        setSSpid('')
      } else if (spidType === "sSpid") {
        setSearch('')
        setWSpid('')
      } else {
        setWSpid('')
        setSSpid('')
      }
      setWsNoteIndex(e.data.notes?.filter(note => note.Note_Type === "Wholesaler").length)
      setPrevWsNotes(e.data.notes?.filter(note => note.Note_Type === "Wholesaler"))
      setWsOutcome(e.data.customer?.WS_Outcome)
      if (displayModuleIssues) {
        setSearchResults(e.data?.issues)
      }
      setLoadingSpid(false)

      setRejectIsDisabled(getRejectIsDisabled({ customer: e.data.customer, qualityAssurance }))
    }).catch(e => {
      console.log(e)
      reset()
      window.alert('Could not find SPID.')
    })
  }, [spid, setSummaryData])

  useEffect(() => {
    if (syncRowHeights) {
      syncRowHeights()
    }
  }, [summaryData])

  useEffect(() => {
    window.onload = syncRowHeights;
    window.onresize = syncRowHeights;
  }, [])

  useEffect(() => {
      window.reloadSummaryData = getSummaryData
  }, [getSummaryData])

  const getWorkflowItems = (spid) => {
    setSpidSearch(spid)
    setSpid(null)
    setSummaryData({})
    if (qualityAssurance && !selectedUser) return
    setLoadingWorkflow(true)
    request(true).get(endpoints[`${prefix}_WF_ITEMS`], {
      doesCancel: true,
      params: {
        outcome: workflowOutcomeSetting,
        user: selectedUser?.value,
        module: selectedModule?.value,
        ...(qualityAssurance && {fromTime: fromTime}),
        ...(qualityAssurance && {toTime: toTime}),
        ...(selectedStatus && {selectedStatus: selectedStatus?.value}),
        ...(spid && {spid: spid}),
      }
    }).then(e => {
      setWorkflowItems(e.data);
      if (e.data.length > 0) {
        setSpid(e.data[_cur && _cur !== -1 ? _cur : 0] ?? e.data[_cur - 1] ?? e.data[0])
      } else {
        reset()
        setSpid()
        setWSpid()
        setSSpid()
        setSearch()
      }
      setLoadingWorkflow(false);
    }).catch(e => {
      console.log(e);
      window.alert('Could not retrieve data')
      setLoadingWorkflow(false)
    })
  }

  const getWorkflowCounts = () => {
    setSearch()
    setSummaryData({})
    setWsOutcome('')
    request(true).get(endpoints[`${prefix}_WF_COUNTTS`]).then(r => {
      setWorkflowCounts(r.data);
    })
  }

  useEffect(() => {
    if (displayModuleIssues){
      return
    }
    window.reloadCounts = () => {
      getWorkflowItems()
      getWorkflowCounts()
    }
}, [getWorkflowCounts, getWorkflowItems])

  useEffect(() => {
      window.reloadWorkflow = getWorkflowItems
  }, [getWorkflowItems])

  var _cur = useMemo(() => {
    return workflowItems.findIndex(_ => _ === spid);
  }, [workflowItems, spid]);

  const refreshCounts = () => {
    if (summaryData.WS_Outcome !== wsOutcome && wsOutcome !== '' && !displayModuleIssues) {
      getWorkflowItems()
      getWorkflowCounts()
    }
  }

  const getWorkflowNext = () => {
    if (_cur !== workflowItems.length-1) {
      refreshCounts()
      setSpid(workflowItems[_cur+1]);
    }
  }

  const getWorkflowLast = () => {
    if (_cur !== 0) {
      refreshCounts()
      setSpid(workflowItems[_cur-1]);
    }
  }

  const updateOutcome = () => {
    if (wsOutcome === summaryData.WS_Outcome) return
    request(true).post(endpoints[`${prefix}_UPDATE_OUTCOMES`], {
      SPID: spid,
      WS_Outcome: wsOutcome,
    }).then(e => {
      // window.alert(e.data);
    }).catch(e => {
      console.log(e)
      window.alert("Update failed.")
    })
  }

  const submitNotes= (noteType) =>{
    request(true).post(endpoints[`${prefix}_SUBMIT_NOTES`], {
      SPID: spid,
      notes: wholesalerNotes,
      noteType: noteType,
      module: summaryData.Module
    }).then(e => {
      // window.alert(e.data);
      setWsNoteIndex(e.data.filter(note => note.Note_Type === "Wholesaler").length)
      setPrevWsNotes(e.data.filter(note => note.Note_Type === "Wholesaler"))
      setWholesalerNotes('')
      window.alert("Note submitted")
    }).catch(e => {
      console.log(e)
      window.alert("Update failed.")
    })
  }

  useEffect(() => {
    if (displayModuleIssues) return
    getWorkflowCounts()
    if (qualityAssurance) {
      request(true).get(endpoints.DATA_CLEANSE_VALIDATION_QA_USERS).then(r => {
        setUsers(Object.keys(r.data).map(key => {return {label: r.data[key], value: key} }))
      })
    }
  }, [])

  useEffect(() => {
    if (summaryData.Core_SPID) {
      setMdsDataReady(false)
      getMDSData(summaryData, setMdsDataReady, prefix, customMDSPostcode, setMdsData, setMdsMeterData)
    }
  }, [summaryData])

  useEffect(() => {
    if (wsOutcome) {
      updateOutcome()
    }
  }, [wsOutcome])

  useEffect(() => {
    _cur = 0;
  }, [workflowOutcomeSetting])

  useEffect(() => {
    if (workflow) {
      getWorkflowItems();
    }
  }, [workflowOutcomeSetting])

  useEffect(() => {
    if (spid && spid !== summaryData.Core_SPID) {
      getSummaryData()
      setMdsDataReady(false);
    }
  }, [spid])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (event.target.id === "wSpid") {
        setMdsDataReady(false);
        getSummaryData(wSpid, "wSpid")
      } else if (event.target.id === "sSpid") {
        setMdsDataReady(false);
        getSummaryData(wSpid, "sSpid")
      } else {
        setWSpid('');
        setSSpid('');
        setSpid(search ? search : spid);
      }
    }
  }

  useEffect(() => {
    if (workflow) {
      getWorkflowItems();
    }
  }, [selectedUser, selectedModule, selectedStatus, fromTime, toTime])

  useEffect(() => {
    if (typeof spidSearch === "undefined") {
      _cur = 0;
      getWorkflowItems()
    }
  }, [spidSearch])

  useEffect(() => {
    if (
      (( summaryData.inPcOrMs && !["MANAGED_SERVICE", "PRIORITY_CLEANSING", "UPRN_CHANGES"].includes(prefix) ) 
      || ( summaryData.Assigned_TO && parseInt(summaryData.Assigned_TO) !== session.user.id ))
    ) {
      setDisabledByUserType(true)
    } else if (["Complete", "Complete & Assured", "Assured"].includes(summaryData.WS_Outcome) || qualityAssurance) {
      setDisabledByUserType(true)
    } else if (session.wholesaler) {
      if ( (summaryData.W_Wholesaler_ID && summaryData.W_Wholesaler_ID === session.wholesaler) || (summaryData.Wholesaler && summaryData.Wholesaler === session.wholesaler) ) {
        setDisabledByUserType(false)
      } else if (!summaryData.W_Wholesaler_ID || !summaryData.Wholesaler) {
        if (summaryData.S_Wholesaler_ID && summaryData.S_Wholesaler_ID === session.wholesaler) {
          setDisabledByUserType(false)
        }
      } else {
        setDisabledByUserType(true)
      }
    }
    if (session.retailer) {
      if ( (summaryData.W_Retailer_ID && summaryData.W_Retailer_ID === session.retailer) || (summaryData.Retailer_ID && summaryData.Retailer_ID === session.retailer) ) {
        setDisabledByUserType(false)
      } else if (!summaryData.W_Retailer_ID || !summaryData.Retailer_ID) {
        if (summaryData.S_Retailer_ID && summaryData.S_Retailer_ID === session.retailer) {
          setDisabledByUserType(false)
        }
      } else {
        setDisabledByUserType(true)
      }
    }
  }, summaryData['Core_SPID'])

  const outcomes = getWorkflowStatuses({module: prefix, isQualityAssurance: qualityAssurance, rejectIsDisabled: rejectIsDisabled})

  return [
    <div style={{ display: 'grid', gap: '10px' }}>
      { workflow && 
        qualityAssurance ?
        <div class="quality-assurance">
          <div>
            <p className="font-weight-600">User</p>
            <Select 
              options={[{label: 'All Users', value: ''}].concat(users)} 
              onChange={ setSelectedUser }
              styles={{
                container: (baseStyles, state) => ({
                  ...baseStyles,
                  display: 'grid'
                }),
              }}
            />
          </div>
          <div>
            <p className="font-weight-600">Module</p>
            <Select 
              options={modules} 
              onChange={ setSelectedModule }
              defaultValue={{ label: 'All Modules', value: '' }}
              styles={{
                container: (baseStyles, state) => ({
                  ...baseStyles,
                  display: 'grid'
                }),
              }}
            />
          </div>
          <div>
            <p className="font-weight-600">From</p>
            <DatePicker time={fromTime} onChange={date => setFromTime(date)}/>
          </div>
          <div>
            <p className="font-weight-600">To</p>
            <DatePicker time={toTime} onChange={date => setToTime(date)}/>
          </div>
          <div>
            <p className="font-weight-600">Status</p>
            <Select 
              options={[{label: 'All Statuses', value: ''}, {label: 'Complete', value: 'Complete'}, {label: 'Quality Check Passed', value: 'Quality Check Passed'}]} 
              onChange={ setSelectedStatus }
              defaultValue={{ label: 'All Statuses', value: '' }}
              styles={{
                container: (baseStyles, state) => ({
                  ...baseStyles,
                  display: 'grid'
                }),
              }}
            />
          </div>
          <div>
            <button className={`button compact smaller-text reject ${selectedUser && selectedStatus?.value && !rejectIsDisabled ? 'cancel' : ''}`} 
              disabled={!selectedUser || !selectedStatus?.value || rejectIsDisabled } 
              onClick={() => { 
                  if ((selectedStatus.value === 'Quality Check Passed')) {
                    if (window.confirm("This dataset contains work that has previously been marked as quality assured. Please confirm you want to bulk reject these.")) {
                      setBulkRejectModelOpen(true);
                    }
                  } else {
                    setBulkRejectModelOpen(true);
                  }
                }}
              >Bulk Reject</button>
          </div>
        </div>
        :
        <div style={{ display: 'grid', gap: '10px', gridAutoFlow: "column", margin: prefix === "PRIORITY_CLEANSING" ? '' : '0em 5em', padding: '1em 0em', overflowX: 'auto', textWrap: 'nowrap' }}>
          {
            workflow && outcomes.filter(outcome => !outcome.disabled ||  outcome.always_filterable).map(outcome => {
              const count = workflowCounts.find(wfCount => wfCount?.WS_Outcome === outcome.value);
              return (
                <button className={`button compact smaller-text ${workflowOutcomeSetting === outcome.value ? "bulk-buy-button" : "background-primary"} colour-white`} onClick={() => {
                  refreshCounts()
                  setWorkflowOutcomeSetting(outcome.value)
                }}>
                  {outcome.label} ({count?.count ?? 0})
                </button>
              )
            })
          }
        </div>
      }
      { summaryData.Module !== "METER_COORDINATION_VALIDAITON" && summaryData.Module !== "PRIORITY_CLEANSING_METER" ? 
        <BAASummaryTable
          translations={translations}
          handleKeyDown={handleKeyDown}
          loadingWorkflow={loadingWorkflow}
          search={search}
          setSearch={setSearch}
          spid={spid}
          workflow={workflow}
          loadingSpid={loadingSpid}
          setSpid={setSpid}
          workflowItems={workflowItems}
          _cur={_cur}
          getWorkflowLast={getWorkflowLast}
          getWorkflowNext={getWorkflowNext}
          summaryData={summaryData}
          wsOutcome={wsOutcome}
          setConfirmModal={setConfirmModal}
          setWsOutcome={setWsOutcome}
          qualityAssurance={qualityAssurance}
          disabledByUserType={disabledByUserType}
          prefix={prefix}
          getWorkflowStatuses={getWorkflowStatuses}
          links={links}
          wSpid={wSpid}
          setWSpid={setWSpid}
          sSpid={sSpid}
          setSSpid={setSSpid}
          getSummaryData={getSummaryData}
          searchResults={searchResults}
          searchIsLoading={searchIsLoading}
          wholesalerNotes={wholesalerNotes}
          setWholesalerNotes={setWholesalerNotes}
          prevWsNotes={prevWsNotes}
          wsNoteIndex={wsNoteIndex}
          setWsNoteIndex={setWsNoteIndex}
          submitNotes={submitNotes}
          displayModuleIssues={displayModuleIssues}
          rejectIsDisabled={rejectIsDisabled}
        />
      :
        <MCVSummaryTable 
          translations={translations} 
          setSearch={setSearch} 
          loadingWorkflow={loadingWorkflow} workflow={workflow}
          search={search} meter={summaryData['Meter_ID']} 
          handleKeyDown={handleKeyDown} 
          getWorkflowLast={getWorkflowLast} workflowItems={workflowItems} getWorkflowNext={getWorkflowNext}
          _cur={_cur}
          setMeter={setSpid}
          summaryData={summaryData}
          wsOutcome={wsOutcome}
          setConfirmModal={setConfirmModal}
          setWsOutcome={setWsOutcome}
          qualityAssurance={qualityAssurance} modules={modules}
          setSpidSearch={setSpidSearch} spidSearch={spidSearch}
          getWorkflowItems={getSummaryData} setCur={(target) => _cur = target}
          disabledByUserType={disabledByUserType}
          rejectIsDisabled={rejectIsDisabled}
        />
      }
    </div>,
    <ReactModal
    isOpen={bulkRejectModelOpen} 
    onRequestClose={() => setBulkRejectModelOpen(false)}
    className="card bulk-reject"
    contentLabel="Data Cleanse Validation - Bulk Reject"
    style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
      <div className='dcv-reject'>
        <p>You are about to reject multiple submissions due to quality concerns. This action <br/> will return the work to the user's workflow queue for further review or updates.<br/>
          Please ensure you have carefully reviewed your selections click "Confirm" if you<br/> are ready to proceed.</p>
        <div>
          <button className="button smaller-text cancel" onClick={ () => setBulkRejectModelOpen(false) }>Cancel</button>
          <button className="button smaller-text background-primary colour-white" onClick={() => {
            setLoadingReject(true)
            request(true).post(endpoints[`${prefix}_BULK_REJECT`], {
              user: selectedUser?.value,
              fromTime: fromTime,
              toTime: toTime,
              module: selectedModule?.value,
              selectedStatus: selectedStatus?.value
            }).then(r => {
              setLoadingReject(false)
              setSummaryData({})
              if (window.reloadCounts) {
                window.reloadCounts()
              }
              setBulkRejectModelOpen(false); 
            }).catch(error => {
              console.log(error)
              setLoadingReject(false)
            })
          }}
          >
            { !loadingReject ?
                "Confirm"
              :
                <div className="spinner" style={{ margin: '0em 1em' }}>
                  <i className="fa fa-spinner fa-spin"></i>
                </div>
            }
          </button> 
        </div>
      </div>
    </ReactModal>
  ]
}
